var map = {
	"./spin-sign.png": 64,
	"./spin-sign@2x.png": 65
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 121;


//////////////////
// WEBPACK FOOTER
// ./themes/fq/img ^\.\/spin\-sign.*\.png$
// module id = 121
// module chunks = d-game